import React, { useEffect, useState } from "react";
import "./Crypto.css";
import Market from "./Market";
function Crypto() {
  const [coins, setCoins] = useState([]);
const [search, setSearch] = useState("");
const [activeTab, setActiveTab] = useState("Favorites");




const favorites = [
  "BTC-USDT",
  "ETH-USDT",
  "SOL-USDT",
  "XRP-USDT",
  "ADA-USDT",
  "DOGE-USDT",
  "TRX-USDT",
  "OKB-USDT",
];


const coinNames = {
  BTC: "Bitcoin",
  ETH: "Ethereum",
  SOL: "Solana",
  XRP: "XRP",
  DOGE: "Dogecoin",
  ADA: "Cardano",
  TRX: "TRON",
  OKB: "OKB",
  BNB: "BNB",
  LTC: "Litecoin",
  BCH: "Bitcoin Cash",
  DOT: "Polkadot",
  LINK: "Chainlink",
  AVAX: "Avalanche",
  TON: "Toncoin",
  SHIB: "Shiba Inu",
  PEPE: "Pepe",
};




const fetchCoins = async (type = activeTab) => {
  let url = "";

  switch (type) {
    case "Favorites":
    case "Spot":
      url = "https://www.okx.com/api/v5/market/tickers?instType=SPOT";
      break;

    case "Futures":
      url = "https://www.okx.com/api/v5/market/tickers?instType=SWAP";
      break;

    case "Events":
      url = "https://www.okx.com/api/v5/market/tickers?instType=SPOT";
      break;

    case "DEX":
      url = "https://www.okx.com/api/v5/market/tickers?instType=SPOT";
      break;

    default:
      url = "https://www.okx.com/api/v5/market/tickers?instType=SPOT";
  }

  try {
    const res = await fetch(url);
    const data = await res.json();

    let list = data.data || [];

    list = list.filter((coin) => coin.instId);

    if (type === "Favorites") {
      list = list.filter((coin) => favorites.includes(coin.instId));
    }
    
    if (type === "Spot") {
      list = list.filter((coin) => coin.instId.endsWith("-USDT"));
    }
    
    if (type === "Futures") {
      list = list.filter((coin) => coin.instId.endsWith("-SWAP"));
    }

    setCoins(list);
  } catch (err) {
    console.log(err);
  }
};

const ads = [
  "🚀 Welcome to Crypto Trading",
  "🔥 BTC trading available 24/7",
  "💰 Deposit and start earning today",
  "📈 ETH, BTC, DOGE & TRX are live",
];

const [index, setIndex] = useState(0);

useEffect(() => {
  const timer = setInterval(() => {
    setIndex((prev) => (prev + 1) % ads.length);
  }, 3000);

  return () => clearInterval(timer);
}, []);



const formatVolume = (value) => {
  const num = Number(value);

  if (num >= 1e12) return `$${(num / 1e12).toFixed(2)}T`;
  if (num >= 1e9) return `$${(num / 1e9).toFixed(2)}B`;
  if (num >= 1e6) return `$${(num / 1e6).toFixed(2)}M`;
  if (num >= 1e3) return `$${(num / 1e3).toFixed(2)}K`;

  return `$${num.toFixed(2)}`;
};




useEffect(() => {
  fetchCoins(activeTab);

  const interval = setInterval(() => {
    fetchCoins(activeTab);
  }, 3000);

  return () => clearInterval(interval);
}, [activeTab]);


const filtered = coins.filter(
  (coin) =>
    coin.instId &&
    coin.instId.toLowerCase().includes(search.toLowerCase())
);

return (

  
<div className="crypto">



<div className="crypto-announcement">
  {ads[index]}
</div>

<Market />



<div className="search-box">  
    <input  
      placeholder="🔍 Search Coin..."  
      value={search}  
      onChange={(e) => setSearch(e.target.value)}  
    />  
  </div>  

  <div className="tabs">
  <button
    className={activeTab === "Favorites" ? "active" : ""}
    onClick={() => setActiveTab("Favorites")}
  >
    Favorites
  </button>

  <button
    className={activeTab === "Spot" ? "active" : ""}
    onClick={() => setActiveTab("Spot")}
  >
    Spot
  </button>

  <button
    className={activeTab === "Futures" ? "active" : ""}
    onClick={() => setActiveTab("Futures")}
  >
    Futures
  </button>

  <button
    className={activeTab === "Events" ? "active" : ""}
    onClick={() => setActiveTab("Events")}
  >
    Events
  </button>

  <button
    className={activeTab === "DEX" ? "active" : ""}
    onClick={() => setActiveTab("DEX")}
  >
    DEX
  </button>
</div>

  




<div className="header">  
    <span>Name</span>  
    <span>Last Price</span>  
    <span>24H</span>  
  </div>  




  {filtered.map((coin) => {  

    const symbol = coin.instId.split("-")[0];  

    return (  

      <div className="coin" key={coin.instId}>  

        <div className="left">  

          <img  
            src={`https://assets.coincap.io/assets/icons/${symbol.toLowerCase()}@2x.png`}  
            alt=""  
            onError={(e)=>{  
              e.target.src="https://cryptologos.cc/logos/bitcoin-btc-logo.png";  
            }}  
          />  

          <div>  

            <h3>{coin.instId}</h3>  

            <p>
  Vol {Number(coin.volCcy24h).toLocaleString()}
</p>




          </div>  



          <p>
  {coinNames[symbol] || symbol} • {formatVolume(coin.volCcy24h)}
</p>


        </div>  

        <div className="price">  

          <h3>{Number(coin.last).toLocaleString()}</h3>  


   

 
        </div>  

        <div>  

        
<div>
  {(() => {
    const last = Number(coin.last);
    const open = Number(coin.open24h);
    const change = open > 0
      ? ((last - open) / open) * 100
      : 0;

    return (
      <button className={change >= 0 ? "green" : "red"}>
        {change > 0 ? "+" : ""}
        {change.toFixed(2)}%
      </button>
    );
  })()}
</div>


        </div>  

      </div>  

    );  

  })}  

</div>

);
}

export default Crypto;
